import glassWallPartTypes from 'components/configurator/types/glassWallPartTypes';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IGlassWallGlass from 'components/interfaces/IGlassWallGlass';
import store from 'store/store';

import {
  DOOR_GLASS_1276,
  DOOR_GLASS_876,
} from 'components/configurator/types/doorGlassTypes';

import {
  isSlidy30,
  isSlidy36,
} from 'components/configurator/types/glazingWallTypesCheck';

import { setWall } from 'store/selectedWall/actions';

import {
  SLIDY_DOOR_30,
  SLIDY_DOOR_36,
} from 'components/configurator/types/doorTypes';

const updateGlazingWallTypeDependenciesOnDoors = (wall: any) => {
  const wallCopy = { ...wall };

  if (isSlidy30(wall) || isSlidy36(wall)) {
    wallCopy.doorSide = 'inside';
  }

  if (isSlidy30(wallCopy)) {
    wallCopy.parts = wall.parts.map((part: IGlassWallDoor | IGlassWallGlass) =>
      part.type === glassWallPartTypes.door
        ? {
            ...part,
            doorGlassType: DOOR_GLASS_876, // preset value: 4+076+4mm
            typeName: SLIDY_DOOR_30,
          }
        : part
    );
  }

  if (isSlidy36(wallCopy)) {
    wallCopy.parts = wall.parts.map((part: IGlassWallDoor | IGlassWallGlass) =>
      part.type === glassWallPartTypes.door
        ? {
            ...part,
            doorGlassType: DOOR_GLASS_1276, // preset value: 6+6 075 SC
            typeName: SLIDY_DOOR_36,
          }
        : part
    );
  }

  store.dispatch(setWall(wallCopy));
};

export default updateGlazingWallTypeDependenciesOnDoors;
